import smileup from '../../assets/images/SmileUp_Cores.png';
import gestus from '../../assets/images/gestus_logo.png';
import TaxBase from '../../assets/images/TaxBase_Cores.png';

const cards = [
  {
    image: gestus,
    text:
      '“Tivemos o nosso primeiro contato com o Bizdocs em 2019, quando estávamos em pleno projeto de digitalização de nossa empresa. O Bizdocs é uma ferramenta essencial numa empresa moderna que quer funcionar com rapidez e eficiência.“',

      //  name: `Nuno Amaral Frazão,`,
occupation: 'Gestus',
    height: '436px'
  },
  {
    image: smileup,
    text:
      '"Antes de instalar o Bizdocs não sabíamos onde andavam as faturas e porque não se encontravam lançadas. Este projeto permitiu-nos criar um único canal de entrada de todas as faturas e automatizar processos para diminuir o tempo de lançamento dos documentos."',
   // name: 'Nuno Amaral Frazão,',
      occupation: 'Smile.Up',
    height: '436px'
  },
  {
    image: TaxBase,
    text: 
      '"Reduzindo a circulação de documentos físicos, além de agilizar o fluxo de informação, o Bizdocs também contribui com a preservação do meio ambiente."',
    //name: 'Nuno Amaral Frazão,',
      occupation: 'Taxbase',
    height: '436px'
  }
];

export default cards;
